// extracted by mini-css-extract-plugin
export default {"container":"StickyColumnHeaders_container__LOq28","header":"StickyColumnHeaders_header__FMpef","title":"StickyColumnHeaders_title__FkB1m"};